import { render, staticRenderFns } from "./ChartsSettings.vue?vue&type=template&id=1394a570&"
import script from "./ChartsSettings.vue?vue&type=script&lang=js&"
export * from "./ChartsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports